import { memo } from 'react';
import { slugify } from '@bridebook/toolbox/src';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { Box } from '@bridebook/ui';
import Badge from '@bridebook/web/app-shared/components/supplier/sections/badges/badge';
import componentStyles from './badges.style';
import { IBadgeWithYear } from '@bridebook/web/app-shared/lib/supplier/types';

interface IProps {
  badges: IBadgeWithYear[];
  supplierCountry?: CountryCodes;
}

const Badges = ({ badges, supplierCountry }: IProps) => {
  if (!badges.length) return null;

  const styles = componentStyles();

  return (
    <Box style={styles.badgeWrapper}>
      {badges.map(({ type, period }) => (
        <Badge
          supplierCountry={supplierCountry}
          type={type}
          year={period.y}
          key={`supplier-badge-${slugify(type)}-${period.y}`}
        />
      ))}
    </Box>
  );
};

export default memo(Badges);
